import * as Constant from './constant';

export const initialState = { totalCount: 0, data: [], loading: false, error: false };

const serverReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constant.LIST_SERVER:
      return {
        ...state,
        loading: true,
        data: [],
        error: false,
      };
    case Constant.LIST_SERVER_SUCCESS:
      return {
        ...state,
        loading: false,
        totalCount: action.payload.total,
        data: action.payload.serverdetails,
        error: false,
      };
    case Constant.LIST_SERVER_ERROR:
      return {
        ...state,
        loading: false,
        data: [],
        error: true,
      };


    default:
      return state;
  }
};

export default serverReducer;
